<template>
  <w-flex class="table-bar-search-title">
  <h1 >{{ title }}</h1>
  <div class="spacer" />
  <slot name="button" />
  </w-flex>
  <w-flex class="table-bar-search">
    <slot name="zfilter">

      <w-input
        v-model="keyword"
        placeholder="Carian..."
        inner-icon-left="wi-search"
        class="xs11 table-bar-input">
      </w-input>
      
    </slot>
    
  </w-flex>

  <slot name="zslider">
  </slot>

  <w-table
    v-bind="$attrs"         
    :loading="loading"
    :filter="ffilter"
    :headers="headers"
    :items="items"
  >

    <!-- the following lines here is a magic, it passed the slot this component received to the sub component -->
    <!-- pass through scoped slots -->
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]="slotData">
      <slot :name="slotName" v-bind="slotData" />
    </template>      

    <template #no-data>
      Tiada maklumat untuk dipaparkan
    </template>
  </w-table>

  <w-card class="table-bar-search-bottom bd0 text-right" >
    <w-flex class="justify-start align-center">
      <w-select label-position="left" v-model="form.perPage" :items="perPageOption" class="xs1" @item-select="loadpg(1)">
      </w-select>
    
      <z-pagination class="xs11" :max="meta.last_page" :path="meta.path" :current="meta.current_page" :links="meta.links"  @pageChanged="loadpg" />
    </w-flex>
  </w-card>

  
  
</template>

<script>
import _ from 'lodash'

export default {
  name: 'z-table',
  inheritAttrs: false,
  props: {
    title: String,
    perPageOption: {
      type: Array,
      default: [
        {label: '5', value: 5},
        {label: '10', value: 10},
        {label: '50', value: 50},
        {label: '9999', value: 9999},
      ]
    },
    headers: [Array, Object],
    items: [Array, Object],
    meta: {
      type: Object,
      default: {
        per_page: 5
      }
    },
    filter: Function,
  },
  data() {
    return {
      form: {
        perPage: parseInt(this.meta.per_page) ?? 10,
      },
      loading: false,
      keyword: '',
      
    }
  },
  watch: {
    meta: {
      handler () {
        this.form.perPage = parseInt(this.meta.per_page)
        // this.loadpg(1)
      },
      deep: true
    }
  },
  computed: {
    ffilter() {
      return (typeof this.filter === 'function') ? this.filter : item  => {
        console.log(this.keyword)
        // dynamically get all the cols and concatenate all the columns into a single string for a faster lookup.
        let allCols = ''
        Object.keys(item).forEach(i => allCols += item[i])
        
        // Lookup the keyword variable in the string with case-insensitive flag.
        return new RegExp(this.keyword, 'i').test(allCols)
        
      }
    }
  },
  methods: {
    loadpg (pg) {
    //  this.loading = true
    console.log(pg + ' - ' + this.meta.current_page + ' - ' + this.meta.per_page + ' - ' + this.form.perPage)
    if(pg != this.meta.current_page || this.meta.per_page != this.form.perPage) {
      this.$inertia.visit(this.meta.path + '?page=' + pg + '&per_page=' + this.form.perPage, { preserveScroll: true, preserveState: true })
    }
    }
  }
}
</script>

<style>
.table-bar-search-title{
    padding: 10px;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
}
.table-bar-search{
    padding: 0px 10px 0px 10px;
}
.table-bar-search .btn-search {
    padding: 32px 5px;
    border-radius: 0px;
    font-size: 11px;
}
.table-bar-lookup{
    padding: 16px 7px 7px 15px;
}
.table-bar-input{
    padding: 16px 7px 7px 7px;
    border: 1px solid #d9d9d9;
}
th.w-table__header {
    padding: 10px;
    font-weight: normal;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
}
.w-table-wrap {
    border: inherit;
    border-radius: inherit;
}
.w-table__cell {
    padding: 7px 7px;
}
.w-table-wrap {
    padding: 0px 10px;
}
.fs-2{
    font-size: 12px !important;
    text-transform: uppercase;
    line-height: 0px;
}
.bs{
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}
.be{
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
.table-bar-search-title h1 {
    line-height: 24px;
}
.w-table__header-sort--inactive {
   opacity: 6;
}

.table-bar-search-advance{
    border-radius: 0px !important;
}
.table-bar-search-advance-inner {
    padding: 10px;
}
.table-bar-search label{
    text-transform: uppercase;
    font-weight: bold;
}
.table-bar-search .w-input{
    margin-top: 0;
}

</style>